<template>
  <div class="upload-video-lecture">
    <div class="upload-video-lecture__body container">
      <div class="row">
        <div class="col-12">
          <div class="upload-video-lecture__header-title typography--color-primary text-center">
            {{ $t('video_lectures.upload_video.header_title') }}
          </div>

          <div class="upload-video-lecture__form">
            <div class="upload-video-lecture__upload-area mx-auto text-center">
              <label class="upload-video-lecture__upload-input text-center clickable w-100">
                <input
                  type="file"
                  class="no-display"
                  accept="video/mp4,video/x-m4v,video/*"
                  @change="onVideoInputChange"
                  :disabled="busy"
                />
              </label>

              <div class="upload-video-lecture__upload-text typography--headline typography--color-secondary">
                {{ $t('video_lectures.upload_video.upload_text') }}
              </div>

              <div class="mt-4" v-if="busy">
                <LoadingBounce></LoadingBounce>
                <div class="typography--body-2 typography--color-disabled pb-5">
                  {{ $t('common.uploading') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="upload-video-lecture__modal-area">
      <b-modal id="video-type-alert"
               class="basic-modal no-header-modal hide-cancel-btn"
               :hide-header="true"
               :ok-title="$t('common.confirm')">
        <div v-html="$t('common.modal.video_type_alert.message')"/>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import { startsWith, omit } from 'lodash';
  import qs from 'query-string';
  import publisherOnly from '@/mixins/publisherOnly';

  export default {
    name: 'upload-video-lecture',

    mixins: [
      publisherOnly,
    ],

    data() {
      return {
        busy: false,
      };
    },

    methods: {
      ...mapActions([
        'setRecentVideoUploadInfoInStore',
        'getVideoLectureUploadUrl',
        'uploadVideoLecture',
      ]),

      onVideoInputChange(event) {
        if (this.busy) {
          return null;
        }

        const images = event.target.files || event.dataTransfer.files;

        if (!images.length) {
          return null;
        }

        const file = images[0];

        if (!file || file.size === undefined || file.type === undefined) {
          return null;
        }

        if (!startsWith(file.type, 'video/')) {
          // alert wrong file type
          return this.$root.$emit('show::modal', 'video-type-alert');
        }

        return this.createMedia(file);
      },

      createMedia(file) {
        if (!window.FileReader) {
          return this.$root.$emit('show::modal', 'file-reader-unsupported-alert');
        }

        const reader = new window.FileReader();

        reader.onload = () => {
          this.uploadVideo(file);
        };

        this.busy = true;

        return reader.readAsDataURL(file);
      },

      uploadVideo(videoFile) {
        this.getVideoLectureUploadUrl()
          .then((uploadInfo) => {
            const [uploadUrl, queryString] = uploadInfo.upload_link.split('?');
            const queryParams = qs.parse(queryString);
            const uploadLink = `${uploadUrl}?${qs.stringify(omit(queryParams, 'redirect_url'))}`;
            const params = {
              uploadLink,
              videoFile,
            };

            return this.uploadVideoLecture(params)
              .then(() => (
                this.setRecentVideoUploadInfoInStore(uploadInfo)
              ))
              .then(() => (
                this.$router.replace('new-video-lecture')
              ));
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .upload-video-lecture {
    .upload-video-lecture__body {
      max-width: 400px;
      padding-bottom: 100px;
    }

    .upload-video-lecture__header-title {
      margin-top: 60px;
      font-size: 28px;
      line-height: 1.79;
    }

    .upload-video-lecture__form {
      margin-top: 40px;
    }

    .upload-video-lecture__upload-area {
      width: 185px;
    }

    .upload-video-lecture__upload-input {
      height: 185px;
      background-image: url('/static/images/baseline-cloud_upload-grey.svg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      transition: background-image 0.2s ease-in-out;
      margin-bottom: -10px;

      &:hover {
        background-image: url('/static/images/baseline-cloud_upload-black.svg');
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/video-lectures/views/UploadVideoLecture.vue